// C:\Users\aleja\Code\inventory_analytics\src\front\src\store\flux\authActions.js

import getApiBaseUrl from "../../utils/api";

const API_URL = getApiBaseUrl();

const authActions = ({ getStore, getActions, setStore }) => ({
  clearAuthState: () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("username");
    localStorage.removeItem("must_change_password");

    setStore({
      token: null,
      role: null,
      username: null,
      mustChangePassword: false,
      isAuthenticated: false,
      authResolved: true,
      userActivityLogs: [],
    });
  },

  login: async (username, password) => {
    try {
      const response = await fetch(`${API_URL}/api/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: username,
          password: password,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        getActions().showToast(
          data?.error || data?.msg || "Credenciales incorrectas",
          "error",
        );
        return { success: false };
      }

      const payload = data || {};
      const token = payload?.access_token || null;
      const user = payload?.user || {};
      const role = user?.role || null;
      const usernameLogged = user?.username || null;
      const mustChangePassword = user?.must_change_password === true;

      if (!token || !role || !usernameLogged) {
        console.error("Login payload inválido: missing required auth fields");
        getActions().showToast("Respuesta de login inválida", "error");
        return { success: false };
      }

      localStorage.setItem("token", token);
      localStorage.setItem("role", role);
      localStorage.setItem("username", usernameLogged);
      localStorage.setItem("must_change_password", String(mustChangePassword));

      setStore({
        token,
        role,
        username: usernameLogged,
        mustChangePassword,
        isAuthenticated: true,
        authResolved: true,
      });

      getActions().showToast("Login correcto", "success");

      return { success: true };
    } catch (error) {
      console.error("Login error:", error);
      getActions().showToast("Server error", "error");
      return { success: false };
    }
  },

  logout: async () => {
    const { token } = getStore();

    if (token) {
      try {
        await fetch(`${API_URL}/api/logout`, {
          method: "POST",
          headers: {
            Authorization: "Bearer " + token,
          },
        });
      } catch (error) {
        console.error("Logout sync error:", error);
      }
    }

    getActions().clearAuthState();

    return { success: true };
  },

  checkAuth: async () => {
    const token = localStorage.getItem("token");

    if (token) {
      try {
        const response = await fetch(`${API_URL}/api/me`, {
          headers: {
            Authorization: "Bearer " + token,
          },
        });

        if (!response.ok) {
          getActions().clearAuthState();
          return { success: false };
        }

        const user = await response.json();

        if (!user?.role || !user?.username) {
          getActions().clearAuthState();
          return { success: false };
        }

        localStorage.setItem("token", token);
        localStorage.setItem("role", user.role);
        localStorage.setItem("username", user.username);
        localStorage.setItem(
          "must_change_password",
          String(user.must_change_password === true),
        );

        setStore({
          token,
          role: user.role,
          username: user.username,
          mustChangePassword: user.must_change_password === true,
          isAuthenticated: true,
          authResolved: true,
        });

        return { success: true };
      } catch (error) {
        console.error("Auth check error:", error);
        getActions().clearAuthState();
        return { success: false };
      }
    }

    getActions().clearAuthState();
    return { success: false };
  },

  handleApiError: async (response) => {
    const actions = getActions();

    if (response.url.includes("/login")) {
      return false;
    }

    if (response.status === 401) {
      actions.clearAuthState();
      sessionStorage.setItem("session_expired", "1");
      window.location.href = "/login";
      return true;
    }

    if (response.status === 403) {
      actions.showToast(
        "No tiene permisos para acceder a este recurso",
        "error",
      );
      return true;
    }

    if (!response.ok) {
      actions.showToast("Error al comunicarse con el servidor", "error");
      return true;
    }

    return false;
  },
});

export default authActions;
